import React from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

const formatDateTime = value => {
  if (!value) return null;
  try {
    return new Date(value).toLocaleString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return null;
  }
};

const SendErrorModal = ({ isOpen, onClose, error, onForce, isForcing }) => {
  const description = error?.description || 'No se ha podido enviar el WhatsApp.';
  const canForce = !!error?.canForce;
  const nextAvailableAt = formatDateTime(error?.nextAvailableAt);

  return (
    <Transition.Root show={isOpen} as={React.Fragment}>
      <Dialog as='div' className='relative z-50' onClose={onClose}>
        <Transition.Child
          as={React.Fragment}
          enter='ease-out duration-300'
          enterFrom='opacity-0'
          enterTo='opacity-100'
          leave='ease-in duration-200'
          leaveFrom='opacity-100'
          leaveTo='opacity-0'
        >
          <div className='fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity' />
        </Transition.Child>

        <div className='fixed inset-0 z-10 overflow-y-auto'>
          <div className='flex min-h-full items-center justify-center p-4 text-center sm:p-6'>
            <Transition.Child
              as={React.Fragment}
              enter='ease-out duration-300'
              enterFrom='opacity-0 scale-95'
              enterTo='opacity-100 scale-100'
              leave='ease-in duration-200'
              leaveFrom='opacity-100 scale-100'
              leaveTo='opacity-0 scale-95'
            >
              <Dialog.Panel className='w-full max-w-md transform overflow-hidden rounded-lg bg-white p-6 text-left shadow-xl transition-all'>
                <div className='flex items-start gap-3'>
                  <div className='flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-amber-100'>
                    <ExclamationTriangleIcon className='h-6 w-6 text-amber-600' />
                  </div>
                  <div className='flex-1'>
                    <Dialog.Title className='text-lg font-semibold text-gray-900'>
                      No se ha podido enviar el WhatsApp
                    </Dialog.Title>
                    <p className='mt-2 text-sm text-gray-700 whitespace-pre-line'>{description}</p>
                    {nextAvailableAt && (
                      <p className='mt-2 text-sm text-gray-500'>
                        Próximo envío disponible: <span className='font-medium text-gray-700'>{nextAvailableAt}</span>
                      </p>
                    )}
                  </div>
                </div>

                <div className='mt-6 flex justify-end gap-2'>
                  <button
                    type='button'
                    onClick={onClose}
                    disabled={isForcing}
                    className='rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50'
                  >
                    Cerrar
                  </button>
                  {canForce && (
                    <button
                      type='button'
                      onClick={onForce}
                      disabled={isForcing}
                      className='rounded-lg bg-amber-600 px-4 py-2 text-sm font-medium text-white hover:bg-amber-700 disabled:opacity-50'
                    >
                      {isForcing ? 'Enviando...' : 'Forzar envío'}
                    </button>
                  )}
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default SendErrorModal;
